import React from 'react';
import { ErrorMessage, Field, Form } from 'formik';
import { Label } from 'flowbite-react';

import FormError from '@/components/forms/FormError';
import XTwitter from '@/components/commons/icons/XTwitter';
import LinkedIn from '@/components/commons/icons/LinkedIn';
import Facebook from '@/components/commons/icons/Facebook';
import Instagram from '@/components/commons/icons/Instagram';
import LinkIcon from '@/components/commons/icons/LinkIcon';
import GitHub from '@/components/commons/icons/GitHub';

import Input from './Input';
import styles from './Personalize.module.css';

function SocialLinksForm({
    status,
}) {
    return (
        <Form className="h-full">
            <div className={styles.formFieldContainer}>
                <div className="pb-4">
                    <div className="flex font-normal text-cleanSlate text-sm">
                        <Label
                            htmlFor="helper"
                            className="block mb-1 text-sm font-medium text-cleanSlate dark:text-cirrusWhite"
                            value="Location"
                        />
                        <span className="bg-gray-200 mb-2 ml-2 px-2 rounded text-sm h-[20px]">Optional</span>
                    </div>

                    <Field
                        id="location"
                        name="location"
                        component={Input}
                        placeholder="Enter your general location"
                    />
                </div>
                <div className="pb-6 pt-6">
                    <div className="flex font-normal text-cleanSlate text-sm">
                        <Label
                            htmlFor="helper-text"
                            className="block mb-1 text-sm font-medium text-cleanSlate dark:text-cirrusWhite"
                            value="LinkedIn"
                        />
                        <span className="bg-gray-200 mb-2 ml-2 px-2 rounded text-sm h-[20px]">Optional</span>
                    </div>

                    <Field
                        id="linkedIn"
                        name="linkedIn"
                        component={Input}
                        icon={LinkedIn}
                        placeholder="https://linkedin.com/in/ryan.cornell-hayes"
                    />
                    <ErrorMessage name="linkedIn">
                        {(msg) => <FormError error={msg} />}
                    </ErrorMessage>

                </div>
                <div className="pb-6">
                    <div className="flex font-normal text-cleanSlate text-sm">
                        <Label
                            htmlFor="helper-text"
                            className="block mb-1 text-sm font-medium text-cleanSlate dark:text-cirrusWhite"
                            value="X"
                        />
                        <span className="bg-gray-200 mb-2 ml-2 px-2 rounded text-sm h-[20px]">Optional</span>
                    </div>

                    <Field
                        id="xTwitter"
                        name="xTwitter"
                        component={Input}
                        icon={XTwitter}
                        placeholder="https://x.com/ryan_cornellhayes"
                    />
                    <ErrorMessage name="xTwitter">
                        {(msg) => <FormError error={msg} />}
                    </ErrorMessage>
                </div>
                <div className="pb-6">
                    <div className="flex font-normal text-cleanSlate text-sm">
                        <Label
                            htmlFor="helper-text"
                            className="block mb-1 text-sm font-medium text-cleanSlate dark:text-cirrusWhite"
                            value="Facebook"
                        />
                        <span className="bg-gray-200 mb-2 ml-2 px-2 rounded text-sm h-[20px]">Optional</span>
                    </div>

                    <Field
                        id="facebook"
                        name="facebook"
                        component={Input}
                        icon={Facebook}
                        placeholder="Facebook profile link"
                    />
                    <ErrorMessage name="facebook">
                        {(msg) => <FormError error={msg} />}
                    </ErrorMessage>
                </div>
                <div className="pb-6">
                    <div className="flex font-normal text-cleanSlate text-sm">
                        <Label
                            htmlFor="helper-text"
                            className="block mb-1 text-sm font-medium text-cleanSlate dark:text-cirrusWhite"
                            value="Instagram"
                        />
                        <span className="bg-gray-200 mb-2 ml-2 px-2 rounded text-sm h-[20px]">Optional</span>
                    </div>

                    <Field
                        id="instagram"
                        name="instagram"
                        component={Input}
                        icon={Instagram}
                        placeholder="Instagram profile link"
                    />
                    <ErrorMessage name="instagram">
                        {(msg) => <FormError error={msg} />}
                    </ErrorMessage>
                </div>
                <div className="pb-6">
                    <div className="flex font-normal text-cleanSlate text-sm">
                        <Label
                            htmlFor="helper-text"
                            className="block mb-1 text-sm font-medium text-cleanSlate dark:text-cirrusWhite"
                            value="GitHub"
                        />
                        <span className="bg-gray-200 mb-2 ml-2 px-2 rounded text-sm h-[20px]">Optional</span>
                    </div>

                    <Field
                        id="gitHub"
                        name="gitHub"
                        component={Input}
                        icon={GitHub}
                        placeholder="GitHub repository link"
                    />
                    <ErrorMessage name="gitHub">
                        {(msg) => <FormError error={msg} />}
                    </ErrorMessage>
                </div>
                <div className="pb-6">
                    <div className="flex font-normal text-cleanSlate text-sm">
                        <Label
                            htmlFor="helper-text"
                            className="block mb-1 text-sm font-medium text-cleanSlate dark:text-cirrusWhite"
                            value="Other"
                        />
                        <span className="bg-gray-200 mb-2 ml-2 px-2 rounded text-sm h-[20px]">Optional</span>
                    </div>

                    <Field
                        id="other_1"
                        name="other_1"
                        component={Input}
                        icon={LinkIcon}
                        placeholder="Share another link"
                    />
                    <ErrorMessage name="other_1">
                        {(msg) => <FormError error={msg} />}
                    </ErrorMessage>
                </div>
                <div className="pb-6">
                    <div className="flex font-normal text-cleanSlate text-sm">
                        <Label
                            htmlFor="helper-text"
                            className="block mb-1 text-sm font-medium text-cleanSlate dark:text-cirrusWhite"
                            value="Other"
                        />
                        <span className="bg-gray-200 mb-2 ml-2 px-2 rounded text-sm h-[20px]">Optional</span>
                    </div>

                    <Field
                        id="other_2"
                        name="other_2"
                        component={Input}
                        icon={LinkIcon}
                        placeholder="Share another link"
                    />
                    <ErrorMessage name="other_2">
                        {(msg) => <FormError error={msg} />}
                    </ErrorMessage>
                </div>

                <FormError error={status?.errors} />
            </div>
        </Form>
    );
}

export default SocialLinksForm;
